import { projectClient } from '../../client/client';

export async function uploadFile({
  id,
  file,
  filename,
}: {
  id: string;
  file: Blob;
  filename?: string | undefined;
}): Promise<void> {
  const uploadUrl = await projectClient('/zambda/{id}/s3-upload').post({ id, filename });
  await fetch(uploadUrl.signedUrl, {
    method: 'PUT',
    body: file,
  });
}
